// Search functionality for knowledge base
import { useState, useMemo } from 'react';

export interface SearchResult {
  articleId: string;
  title: string;
  category: string;
  excerpt: string;
  relevanceScore: number;
}

export const useSearch = (articles: any[], searchQuery: string) => {
  const [recentSearches, setRecentSearches] = useState<string[]>(() => {
    try {
      const stored = localStorage.getItem('kb_recent_searches');
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  });

  const addRecentSearch = (query: string) => {
    if (!query.trim()) return;
    setRecentSearches((prev) => {
      const updated = [query, ...prev.filter((s) => s !== query)].slice(0, 10);
      try {
        localStorage.setItem('kb_recent_searches', JSON.stringify(updated));
      } catch {}
      return updated;
    });
  };

  const results = useMemo(() => {
    if (!searchQuery.trim()) return [];

    const query = searchQuery.toLowerCase();
    const searchTerms = query.split(/\s+/).filter((t) => t.length > 0);

    return articles
      .map((article) => {
        const titleLower = article.title.toLowerCase();
        const contentLower = (article.content || '').toLowerCase();
        const tagsLower = (article.tags || []).join(' ').toLowerCase();
        const categoryLower = (article.category || '').toLowerCase();

        let score = 0;
        let matches = 0;

        searchTerms.forEach((term) => {
          if (titleLower.includes(term)) {
            score += 10;
            matches++;
          }
          if (contentLower.includes(term)) {
            score += 2;
            matches++;
          }
          if (tagsLower.includes(term)) {
            score += 5;
            matches++;
          }
          if (categoryLower.includes(term)) {
            score += 3;
            matches++;
          }
        });

        if (matches === 0) return null;

        const excerpt = article.content
          ? article.content.substring(0, 200) + (article.content.length > 200 ? '...' : '')
          : '';

        return {
          articleId: article.id,
          title: article.title,
          category: article.category,
          excerpt,
          relevanceScore: score,
        };
      })
      .filter((result): result is SearchResult => result !== null)
      .sort((a, b) => b.relevanceScore - a.relevanceScore);
  }, [articles, searchQuery]);

  return {
    results,
    recentSearches,
    addRecentSearch,
  };
};








